export const consoleWarn = (arg, ...args) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn(arg, ...args);
  }
};
